import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Home } from './pages/Home';
import { Legal } from './pages/Legal';
import { CookieNotice } from './components/CookieNotice';
import { useSmoothScroll } from './hooks/useSmoothScroll';
import { useExternalLinksNewTab } from './hooks/useExternalLinksNewTab';
interface AppProps {
  emotion?: 'auto' | 'neutral' | 'curious' | 'happy' | 'angry' | 'sad' | 'sleepy' | 'surprised';
  screenScale?: number;
  /** Which side of the model carries the face — "auto" detects it */
  faceSide?: 'auto' | 'front' | 'back' | 'left' | 'right' | 'top';
  /** Side plates: tuck in on their own ("auto"), or hold them open / closed */
  armsMode?: 'auto' | 'open' | 'closed';
}
export function App({
  emotion = 'auto',
  screenScale = 0.78,
  faceSide = 'auto',
  armsMode = 'auto'
}: AppProps) {
  useSmoothScroll();
  useExternalLinksNewTab();
  return <BrowserRouter data-id="element-0" data-mp="23u9q4cl98ts0">
      <Routes data-id="element-1" data-mp="23v2rey1g2r2r">
        <Route path="/legal" element={<Legal data-id="element-3" data-mp="3ik7e6ay3c1o0" />} data-id="element-2" data-mp="23t8h0dnsuhcx" />
        <Route path="*" element={<Home emotion={emotion} screenScale={screenScale} faceSide={faceSide} armsMode={armsMode} data-id="element-5" data-mp="3ihv048vgebg8" />} data-id="element-4" data-mp="3ikqwhsrnks2k" />
      </Routes>
      <CookieNotice data-id="element-6" data-mp="3rcj5s04xxv5k" />
    </BrowserRouter>;
}